import React from 'react'

export default function NormalButton(props) {
    return (
        <div className='f-b fs-15 chat-dropdown'>
            <button type="button" onClick={props.onClick} className='btn btn-secondary'>
                <div class="btn-data_reg cursor-point d-center" style={props.style ?? {}}>
                    <div class="fs-15 sm-fs-14 f-sb">{props.name}</div>
                </div>
            </button>
        </div>
    )
}

